"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Environment;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Environment = exports["default"] = /*#__PURE__*/function () {
  function Environment() {
    _classCallCheck(this, Environment);
  }
  return _createClass(Environment, null, [{
    key: "get",
    value: function get() {
      if (Environment.isProduction) return 'Production';
      if (Environment.isLocal) return 'Local';
      if (Environment.isTest) return 'Test';
      if (Environment.isDev) return 'Dev';
    }
  }]);
}();
_Environment = Environment;
_defineProperty(Environment, "isLocal", window.location.hostname === 'localhost');
_defineProperty(Environment, "isTest", window.location.hostname.includes('test-'));
_defineProperty(Environment, "isDev", window.location.hostname.includes('dev-klayoapp'));
_defineProperty(Environment, "isProduction", !_Environment.isLocal && !_Environment.isTest && !_Environment.isDev);